'use strict';

module.exports = ['$scope', '$rootScope', '$http', '$sce', '$q', '$timeout', '$modalInstance', 'config', 'ProductionModeSvc', 'ModalSvc', 'ProductionScheduleSvc', 'PermissionSvc', function ($scope, $rootScope, $http, $sce, $q, $timeout, $modalInstance, config, ProductionModeSvc, ModalSvc, ProductionScheduleSvc, PermissionSvc) {
    /* ####### Scope Functions ###### */
    $scope.openDeleteDialog = function () {

        var config = {
            entry_id: $scope.production_schedule_entry.id
        };

        ModalSvc.productionModeCalendarEntryDeleteModal.open(config);

        $modalInstance.close();
    };

    $scope.saveEntryClick = function ($event, addMore) {

        $scope.disableInput = true;
        $scope.error = {};

        var entry = angular.copy($scope.production_schedule_entry);

        entry.plant = $rootScope.plant;

        if ($scope.mode == 'create') {
            // make a save request to server
            ProductionScheduleSvc.create(entry, $rootScope.plant).success(handleSuccess).error(handleErrors);
        } else if ($scope.mode == 'edit') {
            ProductionScheduleSvc.update(entry, $rootScope.plant).success(handleSuccess).error(handleErrors);
        }

        function handleSuccess(data) {
            // fire an event and pass the updated order
            $rootScope.$broadcast('entryUpdated', data);
            $modalInstance.close();

            // enable save buttons
            $scope.disableInput = false;
        }

        function handleErrors(data) {
            $scope.error = data;
            $scope.disableInput = false;
        }
    };

    $scope.cancelClick = function () {
        $modalInstance.close();
    };

    /* ####### END Scope Functions ###### */

    /* ####### Helper Functions ###### */

    /* ####### END Helper Functions ###### */

    $scope.$watch('production_schedule_entry.production_mode', function (newValue, oldValue) {
        if (newValue != oldValue) {
            var productionMode = $scope.production_modes_by_id[newValue]
            if (!$scope.production_schedule_entry.production_rate) {
                $scope.production_schedule_entry.production_rate = productionMode ? productionMode.default_hourly_rate : '';
            }
        }
    });

    /* ####### Initialization ###### */

    $scope.production_schedule_entry = {
        hours_per_day: 8
    };

    $scope.plant_object = {
        id: $rootScope.plant,
        name: PermissionSvc.permissionCache_by_id[$rootScope.plant].plant_name
    };

    $scope.mode = config.entry_id > 0 ? "edit" : "create";

    $scope.production_modes = [];

    PermissionSvc.getPlantPermissions($scope.plant).then(function (permissionsObject) {
        $scope.permissions = permissionsObject.permissions;
    });

    /* ####### END Initialization ###### */

    /* ####### Load Dependent Data ###### */

    var productionModePromise = ProductionModeSvc.loadAll($rootScope.plant);

    function setProductionModes(data) {
        $scope.production_modes = data;
        $scope.production_modes_by_id = ProductionModeSvc.listToIdMap(data);

        // force reload of select box, to fix IE drawing error
        $timeout(function () {
            $("select").css("width", $("select").css("width"));
        }, 10);
    }

    function setProductionEntry(entry) {
        $scope.production_schedule_entry = entry;
        $scope.production_schedule_entry.start_date = moment(entry.start_date, $scope.$root.dateFormat.moment).format($scope.$root.dateFormat.moment);
        $scope.production_schedule_entry.end_date = moment(entry.end_date, $scope.$root.dateFormat.moment).format($scope.$root.dateFormat.moment);
    }

    // get order(if edit) and custom fields for order
    if (config.entry_id > 0) {
        var productionSchedulePromise = ProductionScheduleSvc.get(config.entry_id, $rootScope.plant);

        $q.all([productionModePromise, productionSchedulePromise]).then(function (arrayOfResults) {
            setProductionModes(arrayOfResults[0].data);
            setProductionEntry(arrayOfResults[1].data);
        });
    } else {
        var date = config.start_date ? moment(config.start_date, $scope.$root.dateFormat.moment) : moment();
        $scope.production_schedule_entry.start_date = moment(date).format($scope.$root.dateFormat.moment);

        productionModePromise.then(function (result) {
            setProductionModes(result.data);
        });
    }
    /* ####### END Load Dependent Data ###### */
}];